import produce from "immer";
import { Project } from "../models/projectModel";
import { EDIT_PROJECT, ProjectActionTypes, SET_PROJECT } from "../types/actions";

const projectReducerDefaultState: Project[] =  []; 

const projectReducer = (state : Project[] = projectReducerDefaultState, action : ProjectActionTypes) : Project[] => {
    switch (action.type) {
        case SET_PROJECT:
            return action.projects;
        case EDIT_PROJECT:
            return produce(state, draft => { draft[draft.findIndex(project => project.id === action.project.id)] = action.project; });
        default:
            return state;
    }
}

export default projectReducer
